import { boundingExtent, Extent } from "ol/extent";
import VectorLayer from "ol/layer/Vector";
import { Vector as Vector_src, XYZ } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import { Style as Vector_style } from 'ol/style';


import { highlightedMarkerStyle, iconEnlargementFactor, mapLayerIds, potentialStayStyle, stayMarkerStyle, stayMarkerStyle_large } from "./static_defs";
import { Trip_v2 } from "../../util/tripPlanner_types";
import { Feature, Map } from "ol";


export function getRouteBounds(trip:Trip_v2) {
	let minX:number, minY:number, maxX:number, maxY:number;
	let bbox:Array<number> = trip.directions.routes[0].bbox;
	if (bbox === null || bbox.length != 4) return;
	minX = bbox[0]; minY = bbox[1]; maxX = bbox[2]; maxY = bbox[3];

	return boundingExtent([
		[maxX, maxY],
		[minX, minY],
		[maxX, minY],
		[minX, maxY]
	]);
};

export function clearLayer(layer:VectorLayer<Vector_src>) {
	layer.getSource().clear();
};

let main_layer:TileLayer<XYZ>;
let sat_layer:TileLayer<XYZ>;
let carnav_layer:TileLayer<XYZ>;

export function setLayerVisible(layerId:string) {
	if (main_layer != undefined && sat_layer != undefined && carnav_layer != undefined) {
		if (!mapLayerIds.includes(layerId)) return;
		main_layer.setVisible(layerId === 'main');
		sat_layer.setVisible(layerId === 'sat');
		carnav_layer.setVisible(layerId === 'carnav');

		$(`[setMapLayer][layerId!=${layerId}]`).removeClass("active");
		$(`[setMapLayer][layerId=${layerId}]`).addClass("active");
	};
};

export function init_hereMaps_layers() {
	let url = `/maptile-base/v3/base/mc/{z}/{x}/{y}/png8&style=explore.day`;
	const main_source = new XYZ({
		url: url
	});
	main_layer = new TileLayer({
		source: main_source,
		zIndex: 0
	});

	url = `/maptile-base/v3/base/mc/{z}/{x}/{y}/png8&style=lite.day`;
	const carnav_source = new XYZ({
		url:url
	})
	carnav_layer = new TileLayer({
		source: carnav_source,
		zIndex: 0,
		visible: false
	});

	url = `/maptile-base/v3/base/mc/{z}/{x}/{y}/png8&style=explore.satellite.day`;
	const sat_source = new XYZ({
		url:url
	})
	sat_layer = new TileLayer({
		source: sat_source,
		zIndex: 0,
		visible: false
	});

	return [main_layer, sat_layer, carnav_layer];
};

let enlargeIcon_orig_zindex:number|undefined = undefined;

export function enlargeIcon(feature:Feature, enlargementFactor:number|null) {
	if (feature == undefined || feature == null) return;
	if (enlargementFactor === null) {
		enlargementFactor = iconEnlargementFactor;
	};
	let style:Vector_style = feature.getStyle() as Vector_style;
	style = style.clone();
	let img = style.getImage();
	img.setScale(img.getScale() as number * enlargementFactor);

	enlargeIcon_orig_zindex = style.getZIndex();
	style.setZIndex(100);
	feature.setStyle(style);
	feature.changed();
};

export function shrinkIcon(feature:Feature, enlargementFactor:number|null) {
	if (feature == undefined || feature == null) return;
	if (enlargementFactor === null) {
		enlargementFactor = iconEnlargementFactor;
	};
	let style:Vector_style = feature.getStyle() as Vector_style;
	style = style.clone();
	let img = style.getImage();
	img.setScale(img.getScale() as number/enlargementFactor);

	if (enlargeIcon_orig_zindex !== undefined) {
		style.setZIndex(enlargeIcon_orig_zindex);
	};
	feature.setStyle(style);
	feature.changed();
};

export function getPoiMarker_fromPoiId(poiID:number) {
	const features:Feature[] = window.poiMarkerLayer.getSource().getFeatures();
	for (let i:number = 0; i < features.length; i++) {
		const properties = features[i].getProperties();
		if (properties.poiID == poiID) {
			return features[i];
		};
	};
	return null;
};

export function getStopMarker_fromStopID(stopID:string) {
	const features:Array<Feature> = window.mainMapMarkerLayer.getSource().getFeatures();
	for (let i:number = 0; i < features.length; i++) {
		const properties = features[i].getProperties();
		if (properties.stopID == stopID) {
			return features[i];
		};
	};
	return null;
};

export function getStopMarker(legIndex:number, stopIndex:number) {
	const features:Array<Feature> = window.mainMapMarkerLayer.getSource().getFeatures();
	for (let i:number = 0; i < features.length; i++) {
		const properties = features[i].getProperties();
		if (properties.leg == legIndex && properties.stopNumInLeg == stopIndex) {
			return features[i];
		};
	};
	return null;
};

export function getStayMarker(campID:number) {
	const features:Array<Feature> = window.clusterMarkerLayer.getSource().getFeatures();
	for (let i:number = 0; i < features.length; i++) {
		const properties = features[i].getProperties();
		if (properties.campID == campID) {
			return features[i];
		};
	};
	return null;
};

export function fitBounds(map:Map, bounds:Extent) {
	const mapWidth: number = map.getSize()[0];
	const mapHeight = map.getSize()[1];

	map.getView().fit(bounds, {
		size: map.getSize(),
		duration: 1000,
		padding: [
			mapHeight * 0.1,
			mapWidth * 0.2,
			mapHeight * 0.1,
			mapWidth * 0.2
		]
	});
};

export function highlightStayPin(marker:Feature) {
	marker.setStyle(stayMarkerStyle_large);
};
export function unhighlightStayPin(marker:Feature) {
	marker.setStyle(stayMarkerStyle);
};

export function highlightMarker(marker:Feature) {
	if (marker == undefined || marker == null) return;
	marker.setStyle(highlightedMarkerStyle);
	window.highlightedMarker = marker;
	window.clusterMarkerLayer.getSource().removeFeature(marker);
	// enlargeIcon(window.highlightedMarker, null);
	window.highlightedMarkerLayer.getSource().addFeature(marker);
};

export function clear_highlightedMarker() {
	if (window.highlightedMarker == null || window.highlightedMarker == undefined) return;
	window.highlightedMarkerLayer.getSource().clear();
	window.highlightedMarker.setStyle(potentialStayStyle);
	// shrinkIcon(window.highlightedMarker, null);
	window.clusterMarkerLayer.getSource().addFeature(window.highlightedMarker);
	window.highlightedMarker = null;
};